import React from 'react';
import { ArrowLeftIcon, BellIcon, SearchIcon, MapPinIcon } from '../common/Icons';

export const SimpleHeader = ({ title, onBack }) => {
  return (
    <div className="p-4 bg-white border-b flex items-center">
      {onBack && (
        <button className="mr-3" onClick={onBack}>
          <ArrowLeftIcon size={24} />
        </button>
      )}
      <h1 className="text-xl font-bold">{title}</h1>
    </div>
  );
};

export const HomeHeader = ({ onNotificationClick, searchValue, onSearchChange }) => {
  return (
    <div className="p-4 bg-white">
      <div className="flex justify-between items-center mb-4">
        <h1 className="text-3xl font-bold text-blue-600">SALON</h1>
        <button className="relative" onClick={onNotificationClick}>
          <BellIcon size={24} />
          <div className="absolute -top-1 -right-1 bg-red-500 text-white rounded-full w-5 h-5 flex items-center justify-center text-xs">
            3
          </div>
        </button>
      </div>
      <div className="flex bg-gray-100 rounded-full p-2 items-center">
        <SearchIcon size={20} className="text-gray-500 ml-2 mr-2" />
        <input
          className="bg-transparent flex-1 outline-none"
          placeholder="Caută serviciu, salon"
          type="text"
          value={searchValue}
          onChange={onSearchChange}
        />
        <div className="flex items-center bg-white rounded-full px-3 py-1 ml-2 text-blue-600">
          <MapPinIcon size={16} className="mr-1" />
          <span className="text-sm">Locația ta</span>
        </div>
      </div>
    </div>
  );
};

export const SearchHeader = ({ searchValue, onSearchChange }) => {
  return (
    <div className="p-4 bg-white sticky top-0 z-10">
      <div className="flex bg-gray-100 rounded-full p-2 items-center">
        <SearchIcon size={20} className="text-gray-500 ml-2 mr-2" />
        <input
          className="bg-transparent flex-1 outline-none"
          placeholder="Toate serviciile în jurul locației tale"
          type="text"
          value={searchValue}
          onChange={onSearchChange}
        />
        <button className="bg-gray-200 rounded-full p-1 ml-2">
          <SearchIcon size={16} />
        </button>
      </div>
    </div>
  );
};